import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { maskName } from '~/utils/common';

import type { TypeDeliveryAgencyCreatedShippingLabel } from '~/types/delivery-agency.types';

const getDeliveryAgencyCreatedShippingLabelsColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeDeliveryAgencyCreatedShippingLabel>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'shippingLabelNumber',
      header: '추가 운송장 번호',
      size: 245,
    },
    {
      accessorKey: 'outboundCode',
      header: '출고번호',
      size: 160,
    },
    {
      accessorKey: 'receiverName',
      header: '수령자명',
      size: 100,
      cell: ({ row }) => maskName(row.original.receiverName) ?? '-',
    },
    {
      accessorKey: 'productName',
      header: '상품명',
      minSize: 252,
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyCreatedShippingLabelsColumnDefs;
